import React, { Component } from "react";
class Sell extends Component {
  render() {
    return (
      <>
        <section className="lg:relative  bg-gray-200 ">
          <div className="mx-auto max-w-screen-2xl grid grid-cols-4 py-32 gap-12 ">
            <div className=" text-center  col-span-full mb-12">
              <h2 className="font-black text-5xl "> Your Voice. Your Brand.</h2>
              <p className="text-3xl leading-tight mt-2 font-light ">
                Connect with your customers directly with your brand of service.{" "}
              </p>
            </div>
            <div></div>
            <div className="text-xl leading-relaxed ">
              {" "}
              <img src="images/icon.svg" alt="" className="pb-8" />
              <span className="font-bold">Your own mobile app.</span> <br />
              Connect with your customers directly with your brand of service.
              Your customers find you directly from an app on thier phone.
            </div>
            <img src="images/teacher-train.svg" alt="" className="" />
          </div>
        </section>
        <section className="lg:relative  bg-gray-200  ">
          <div className="mx-auto max-w-screen-2xl grid grid-cols-4 py-32 gap-12  ">
            <div className=" text-center col-span-full mb-12">
              <h2 className="font-black text-6xl px-64 leading-snug">
                Structure your services just the way you want.
              </h2>
            </div>
            <img src="images/offer-ui.svg" alt="" />
            <img src="images/peru.svg" alt="" className="" />
            <img src="images/offer2-ui.svg" alt="" />
            <img src="images/chickpea.svg" alt="" className="" />
          </div>
        </section>
        <section className="lg:relative  bg-gray-200 ">
          <div className="mx-auto max-w-screen-2xl grid grid-cols-4 py-32 gap-12  ">
            <div className=" text-center  col-span-full mb-12 ">
              <h2 className="font-black text-5xl "> Mobile First Business</h2>
              <p className="text-3xl leading-tight mt-2 font-light">
                Mobile is personal. So is the outreach.{" "}
              </p>
            </div>
            <div></div>
            <div className="text-xl leading-relaxed ">
              {" "}
              <p className="mt-24">
                All the tools you need to draft and publish the right messaging
                -
                <b>
                  {" "}
                  push notifications, sales & deals, announcements, events, etc.
                </b>
              </p>
              <img src="images/msg-ui.svg" alt="" className="mt-6" />
            </div>
            <img src="images/my-schedule.svg" alt="" className="" />

            <div className="pt-64">
              <img src="images/watch.svg" className="w-32" />
            </div>
          </div>
        </section>
        <section className="lg:relative  bg-gray-200 ">
          <div className="mx-auto max-w-screen-2xl grid grid-cols-4 py-32 gap-12  ">
            <div className=" text-center  col-span-full mb-12 ">
              <h2 className="font-black text-5xl ">
                {" "}
                Usage Analytics + Actionable Insights
              </h2>
              <p className="text-3xl leading-tight mt-2 font-light">
                Make informed decisions with insights into your customers
                interactions, sales, bookings, communications, growth trends,
                POS interactions, etc.{" "}
              </p>
            </div>
            <img src="images/metrics1.svg" alt="" />
            <img src="images/msg-ui.svg" alt="" />
            <img src="images/msg-ui.svg" alt="" />
            <img src="images/msg-ui.svg" alt="" />
            <img src="images/metrics1.svg" alt="" />
            <img src="images/msg-ui.svg" alt="" />
            <img src="images/metrics1.svg" alt="" />
            <img src="images/msg-ui.svg" alt="" />
          </div>
        </section>
      </>
    );
  }
}

export default Sell;
